/**
 * @module Form
 */
(function Booking() {

    /**
     * Interaction handling for a form element which is has the possibility to appear multiple
     * This is a cloned and customized version of TechDivisionForm.Multiplicity
     *
     *
     * @class Multiplicity
     * @param {jQuery} domContainer The container of the elements
     * @constructor
     */
    function Multiplicity(domContainer) {
        // context
        var _this = this;
        /**
         * The container around
         * @type {jQuery} dom
         */
        var container = domContainer;
        // selector for a single element
        var elementSelector = '[data-tdform-multiplicity="element"]';
        // selector for a wrapper around the actions
        var actionsSelector = '[data-tdform-multiplicity="actions"]';
        // delete action selector
        var deleteActionSelector = '[data-tdform-multiplicity="delete"]';
        // add action selector
        var addActionSelector = '[data-tdform-multiplicity="add"]';
        // prototype selector for cloning
        var protoTypeSelector = '[data-tdform-multiplicity="participantsContainer"]';
        // multiplicity cloned selector
        var multiplicitySelector = '[data-tdform-multiplicity="participantsContainerCloned"]';

        /**
         * The element dom prototype for cloning
         * @type {jQuery} dom
         */
        var elementPrototype = container.find(protoTypeSelector).find(elementSelector).clone();

        /**
         * @method init
         */

        this.init= function() {
            var number = 1;
            this.bindEvents(container.find(protoTypeSelector).find(elementSelector), number);
            // remove delete action for first element after prototype cloning
            container.find(deleteActionSelector).hide();
        };

        /**
         * Builds a new element with the given index. The index is important for name of the input fields
         * @param {integer} number
         * @returns {jQuery} Dom object
         */
        this.buildNewElement = function(number) {
            var element = elementPrototype.clone();
            // replace the name with given index number
            element.find('input,select,textarea').each(function(idx, element){
                $(element).attr('name', $(element).attr('name').replace("[0]", "[" + number + "]"));
            });
            element.find('[data-optional-participants="field"]').each(function(idx, element){
                element.removeAttribute("required");
            });
            element.find('[data-optional-participants="marker"]').each(function(idx, element){
                $(element).remove();
            });

            return element;
        };

        /**
         * Removes the given element, shows the actions of the new last element
         * @param {jQuery} element Dom object
         */
        this.delete = function(element) {
            // show the second elements actions
            container.find(multiplicitySelector).find(elementSelector).eq(-2).find(actionsSelector).slideDown();
            element.slideUp(400, function(){
                element.remove();
            });
        };

        /**
         * Adds a new element, hides the actions of second last element
         */
        this.add = function() {
            var amountElements = $(elementSelector).length;
            var newElement = _this.buildNewElement(amountElements);
            newElement.hide();
            newElement.insertBefore('[data-tdform-multiplicity="buttonContainer"]');
            newElement.slideDown();

            if (container.find(multiplicitySelector).find(elementSelector).length === 1) {
                container.find(multiplicitySelector).find(deleteActionSelector).slideDown();
            }
        };

        /**
         * Binds the events to the action elements
         */
        this.bindEvents = function() {
            container.find(multiplicitySelector).find(deleteActionSelector).click(function() {
                _this.delete(container.find(elementSelector).last());
            });

            container.find(multiplicitySelector).find(addActionSelector).click(function() {
                _this.add();
            });
        };

        /**
         * initialize call
         */
        _this.init();

    }

    // define the global scope
    if (!window.BikeAlpin) {
        window.BikeAlpin = {};
    }

    window.BikeAlpin.Multiplicity = Multiplicity;

})();


// default dom.ready listener, features are not needed in neos backend
$(document).ready(function () {
    var atLeastOneBookingForm = false;
    // default multiplicity rendering
    $('[data-tdform-multiplicity="form-container"]').each(function (idx, element) {
        var multiplicity = new BikeAlpin.Multiplicity($(element));
        atLeastOneBookingForm = true;
    });

    // add scroll-padding-top for correct scrolling to validation messages
    if (atLeastOneBookingForm === true) {
        var headerHeight = $("[data-html-element='header']")[0].clientHeight;
        var offsetScrolling = 50;
        // add initial
        $("html").css('scroll-padding-top', headerHeight + offsetScrolling + 'px');
        // listen for resize
        $(window).resize(function () {
            headerHeight = $("[data-html-element='header']")[0].clientHeight;
            $("html").css('scroll-padding-top', headerHeight + offsetScrolling + 'px');
        })
    }
});




